import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AgeCalculationService {

  constructor() { }

  ageFromBirthYear(birthYear) {
    var currentYear = new Date().getFullYear();
    var age = 0;

    if (currentYear >= birthYear) {
      age = currentYear - birthYear;
    }

    return age;
  }

  birthYearFromAge(age) {
    var currentYear = new Date().getFullYear();
    return currentYear - age;
  }

  birthyearsFromTo(fromAge, toAge) {
    var fromYear = this.birthYearFromAge(fromAge);
    var toYear = this.birthYearFromAge(toAge);
    var years = [];
    for (var i = fromYear; i > toYear; i--) {
      years.push(i);
    }
    return years;
  }
}
